import React from 'react';
import { useNavigate } from 'react-router-dom';
/** Components Import */
import EmptyBox from '../../Components/EmptyBox';
import Card from '../../Components/Card_wrap';
import BasicArea from '../../Components/PDA/BarcodeArea';
import BasicInput from '../../Components/Input_Basic';
import BasicCombo from '../../Components/Combo_Basic';
import CardH3 from '../../Components/Card_H3';
import Snackbar from '../../Components/Snackbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleArrowRight as RightArrows,
    faClipboardCheck as OrderComplete,
    faHourglassHalf as StandBy,
    faBoxOpen as Producted,
    faBox as Packing,
    faTruckArrowRight as Delivery,
} from '@fortawesome/free-solid-svg-icons';
import BasicButton from '../../Components/Button_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import GridModal from '../../Components/Modal_Grid';
import Commons from '../../Services/Common/Common';
function SM10060(props) {
    React.useEffect(() => {
        if (document.title === '출하지시(PDA)') {
            return;
        } else {
            document.title = '출하지시(PDA)';
            const element = document.getElementById('topbar');
            element.innerHTML =
                '<h1>' +
                "<span class='bullet'>" +
                '</span>' +
                "<strong class='depth-1'>" +
                '영업관리' +
                '	</strong>' +
                "<span class='divider' >" +
                '</span>' +
                "<strong'>출하지시(PDA)</strong>" +
                '</h1>';
        }
    }, []);
    React.useEffect(() => {
        const HandleEnterKey = (e) => {
            const { key, keyCode } = e;
            if (keyCode === 13) {
                navigator.clipboard.readText().then((clipboardText) => {
                    if (clipboardText.length === 12) {
                        props.GetBarcodeLotno(clipboardText);
                    } else {
                        setSnackbars({
                            toggle: true,
                            type: 'error',
                            message: 'Barcode번호를 확인해주세요',
                        });
                    }
                });
            }
        };
        window.addEventListener('keypress', HandleEnterKey);

        return () => window.removeEventListener('keypress', HandleEnterKey);
    });
    const [selectedModalData, setSelectedModalData] = React.useState(null);
    const [modalToggle, setModalToggle] = React.useState(false);
    const [modalToggle1, setModalToggle1] = React.useState(false);
    const navigate = useNavigate();
    const [snackbars, setSnackbars] = React.useState({
        toggle: false,
        type: '',
        message: '',
    });
    const gridRef = React.useRef();
    const gridRef2 = React.useRef();
    const columnDef = [
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
            hide: true,
        },
        //납기일
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 95,
        },
        //출하지시일자
        {
            field: 'delivOrderDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderDt' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 95,
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 95,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 200,
        },
        //출하지시수량
        {
            field: 'delivOrderQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 80,
        },

        //출하지시번호
        {
            field: 'delivOrderNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DelivOrderNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
            editable: true,
        },
    ];
    const columnDef1 = [
        //상태
        {
            field: 'stusNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PoSatusNm' && f.lanType === 'COL')[0].lanName
                    : '', //진행상태
            minWidth: 100,
            // cellRenderer: Commons.CustomHeaderRenderer,
            // cellStyle: { color: "red" },
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
        },

        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'left' },
            editable: false,
            minWidth: 100,
        },
        //납기일
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //출하수량
        {
            field: 'delivQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            minWidth: 120,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
    ];
    const autoGroupColumnDef = React.useMemo(() => {
        //그룹설정
        return {
            headerName: '품명',
            minWidth: 200,
        };
    }, []);
    const rowGroupPanelShow = 'onlyWhenGrouping';
    const groupDefaultExpanded = 1;
    const columnDef2 = [
        //수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemQty' && f.lanType === 'COL')[0].lanName
                    : '',
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            aggFunc: 'sum',
        },
        //LotNo
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 120,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            rowGroup: true,
            hide: true,
        },
    ];
    return (
        <div>
            <EmptyBox />
            <BasicArea
                inputValue={props.inputs.barcodeValue}
                onInputChange={(e) => {
                    props.setInputs({
                        ...props.inputs,
                        barcodeValue: e,
                    });
                }}
                switchValue={props.inputs.switchValue}
                onSwitchChange={(e) => {
                    props.setInputs({
                        ...props.inputs,
                        switchValue: e,
                    });
                }}
                onInputKeyDown={(e) => {
                    if (props.inputs.barcodeValue.length === 12) {
                        props.GetBarcodeLotno(props.inputs.barcodeValue);
                    } else {
                        setSnackbars({
                            toggle: true,
                            type: 'error',
                            message: 'Barcode번호를 확인해주세요',
                        });
                    }
                }}
                autoFocus={true}
            />
            <Card
                wrapStyle={{
                    height: '6.5vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'start',
                }}
            >
                <ul className="tab_nav" style={{ marginTop: '5px' }}>
                    <li>
                        <a className={props.tabToggle ? '' : 'active'} onClick={() => props.setTabToggle(false)}>
                            {props.lanData.length > 0
                                ? props.lanData.filter((f) => f.lanId === 'Btn_Shipment' && f.lanType === 'BTN')[0]
                                      .lanName
                                : ''}
                        </a>
                    </li>
                    <li>
                        <a className={!props.tabToggle ? '' : 'active'} onClick={() => props.setTabToggle(true)}>
                            {props.lanData.length > 0
                                ? props.lanData.filter(
                                      (f) => f.lanId === 'Btn_ShipmentCancel' && f.lanType === 'BTN'
                                  )[0].lanName
                                : ''}
                        </a>
                    </li>
                </ul>
            </Card>
            <Card
                wrapStyle={{
                    height: '14vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'start',
                }}
            >
                <BasicInput
                    name="출하지시번호"
                    containerStyle={{ flexWrap: 'noWrap', width: '300px' }}
                    value={props.inputs.delivOrderNo}
                    // onChange={(e) => {
                    //   props.setInputs({
                    //     ...props.inputs,
                    //     delivOrderNo: e.target.value,
                    //   });
                    // }}
                    disabled={true}
                />
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        // textAlign: "space-between",
                        alignItems: 'start',
                    }}
                >
                    <BasicButton
                        name="출하지시번호"
                        onClick={(e) => {
                            setModalToggle(true);
                            props.Init(3);
                        }}
                    />
                    {/* <BasicButton
            name="상세품목"
            onClick={(e) => {
              setModalToggle1(true);
            }}
          /> */}
                    <BasicButton
                        name="삭제"
                        onClick={(e) => {
                            props.DeleteRow();
                        }}
                    />
                </div>
            </Card>
            <Card
                wrapStyle={{
                    height: '42vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'start',
                }}
            >
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '260px' }}>
                    <AgGridReact
                        ref={gridRef2}
                        animateRows={true}
                        columnDefs={columnDef2}
                        // groupDefaultExpanded={groupDefaultExpanded}
                        // groupIncludeTotalFooter={true}
                        autoGroupColumnDef={autoGroupColumnDef}
                        suppressAggFuncInHeader={true}
                        // rowGroupPanelShow={rowGroupPanelShow}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        rowData={props.rowData2}
                        // rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef2, props.setSelectedRowData)}
                        rowSelection="multiple"
                        enableCellChangeFlash={true}
                        // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                    />
                </div>
            </Card>
            <Card
                wrapStyle={{
                    height: '7vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    alignItems: 'start',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'end',
                        // textAlign: "space-between",
                        alignItems: 'start',
                    }}
                >
                    <BasicButton
                        name="출하"
                        onClick={(e) => {
                            // setModalToggle(true);
                            props.CreateDeliv(new Date());
                        }}
                    />
                </div>
            </Card>
            {modalToggle && (
                <GridModal
                    containerStyle={{ width: '330px' }}
                    gridStyle={{ width: '320px', height: '370px' }}
                    name="출하지시번호"
                    onClose={() => setModalToggle(false)}
                    gridColumn={columnDef}
                    gridRowData={props.rowData}
                    buttonName1={
                        props.lanData.length > 0
                            ? props.lanData.filter((f) => f.lanId === 'Btn_Save' && f.lanType === 'BTN')[0].lanName
                            : ''
                    }
                    gridOnClick={(e) => {
                        let data = [];
                        for (let i = 0; i < e.length; i++) {
                            data.push({
                                delivOrderNo: e[i].delivOrderNo,
                                delivOrderQty: e[i].delivOrderQty,
                                soDueDt: e[i].soDueDt,
                                itemCd: e[i].itemCd,
                                soNo: e[i].soNo,
                            });
                        }
                        setSelectedModalData(data);
                    }}
                    gridOnDoubleClick={(e) => false}
                    execLogic={() => {
                        props.setInputs({
                            ...props.inputs,
                            delivOrderNo: selectedModalData[0].delivOrderNo,
                            delivQty: selectedModalData[0].delivOrderQty,
                            soDueDt: selectedModalData[0].soDueDt,
                            soNo: selectedModalData[0].soNo,
                            itemCd: selectedModalData[0].itemCd,
                        });
                        console.log(selectedModalData);
                        props.setRowData2([]);
                    }}
                />
            )}

            {snackbars.toggle && <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />}
        </div>
    );
}

export default SM10060;
